// console.log("teste de console");

"use strict";
var copa=new Vue( {
    el:"#tab-copa", data: {
        jogos: [], car_jogos: []
    }
    , created:function() {
        this.init_jogos()
    }
    , methods: {
        init_jogos:function() {
            this.$http.get("https://files.metropoles.com/copa-do-mundo/jogos.json?v="+Date.now(), {}
            ).then(function(a) {
                this.jogos=a&&a.data&&Object.values(a.data), setTimeout(function() {
                    var a=$(".rodadas").owlCarousel( {
                        loop:!0,
                        items:1,
                        itemsDesktop: 1,
                        itemsDesktopSmall: 1,
                        itemsTablet: 1,
                        itemsTabletSmall: 1,
                        itemsMobile: 1,
                        margin:1
                    }
                    );
                    $(".next").click(function() {
                        a.trigger("owl.next")
                    }
                    ), $(".prev").click(function() {
                        a.trigger("owl.prev")
                    }
                    )
                }
                , 500)
            }
            , function(a) {
                console.log("Fetch Failed")
            }
            )
        }
        , print:function(a) {
            console.log(JSON.stringify(a, " ", " "))
        }
        , partidas_hoje:function(a) {
            var e=[], r=new Date, s=r.getDate(), c=r.getMonth()+1, n=r.getFullYear(), i=(r.getHours(), s+"/0"+c+"/"+n);
            for(var o in a)for(var t in a[o])for(var b in a[o][t])a[o][t][b][0]==i&&(a[o][t][b][8]=t, e.push(a[o][t][b]));
            return e
        }
        , placar:function(a, e) {
            var r=a.split(":"), s=parseInt(r[0]);
            return(new Date).getHours()<=s?" ": e
        }
        , sigla:function(a) {
            var e="";
            switch(a) {
                case"Arábia Saudita": e="ARA";
                break;
                case"Portugal": e="POR";
                break;
                case"Egito": e="EGI";
                break;
                case"Rússia": e="RUS";
                break;
                case"Uruguai": e="URU";
                break;
                case"Espanha": e="ESP";
                break;
                case"Irã": e="IRA";
                break;
                case"Marrocos": e="MAR";
                break;
                case"Austrália": e="AUS";
                break;
                case"Dinamarca": e="DIN";
                break;
                case"França": e="FRA";
                break;
                case"Peru": e="PER";
                break;
                case"Argentina": e="ARG";
                break;
                case"Croácia": e="CRO";
                break;
                case"Islândia": e="ISL";
                break;
                case"Nigéria": e="NIG";
                break;
                case"Brasil": e="BRA";
                break;
                case"Costa Rica": e="COS";
                break;
                case"Sérvia": e="SER";
                break;
                case"Suiça": e="SUI";
                break;
                case"Alemanha": e="ALE";
                break;
                case"Coréia do Sul": e="COR";
                break;
                case"México": e="MEX";
                break;
                case"Suécia": e="SUE";
                break;
                case"Bélgica": e="BEL";
                break;
                case"Inglaterra": e="ING";
                break;
                case"Panamá": e="PAN";
                break;
                case"Tunísia": e="TUN";
                break;
                case"Colômbia": e="COL";
                break;
                case"Japão": e="JAP";
                break;
                case"Polônia": e="POL";
                break;
                case"Senegal": e="SEN";
                break;
                default: e="LOAD"
            }
            return e
        }
        , changeGrupo:function(a) {
            var e="";
            switch(a) {
                case 0: e="A";
                break;
                case 1: e="B";
                break;
                case 2: e="C";
                break;
                case 3: e="D";
                break;
                case 4: e="E";
                break;
                case 5: e="F";
                break;
                case 6: e="G";
                break;
                case 7: e="H";
                break;
                default: e="LOAD"
            }
            return e
        }
        , imagens:function(a) {
            var e="";
            switch(a) {
                case"Arábia Saudita": e="ArabiaSaudita.png";
                break;
                case"Egito": e="Egito.png";
                break;
                case"Rússia": e="Russia.png";
                break;
                case"Uruguai": e="Uruguai.png";
                break;
                case"Espanha": e="Espanha.png";
                break;
                case"Irã": e="Ira.png";
                break;
                case"Marrocos": e="Marrocos.png";
                break;
                case"Portugal": e="Portugal.png";
                break;
                case"Austrália": e="Australia.png";
                break;
                case"Dinamarca": e="Dinamarca.png";
                break;
                case"França": e="Franca.png";
                break;
                case"Peru": e="Peru.png";
                break;
                case"Argentina": e="Argentina.png";
                break;
                case"Croácia": e="Croacia.png";
                break;
                case"Islândia": e="Islandia.png";
                break;
                case"Nigéria": e="Nigeria.png";
                break;
                case"Brasil": e="Brasil.png";
                break;
                case"Costa Rica": e="CostaRica.png";
                break;
                case"Sérvia": e="Servia.png";
                break;
                case"Suiça": e="Suica.png";
                break;
                case"Alemanha": e="Alemanha.png";
                break;
                case"Coréia do Sul": e="CoreiadoSul.png";
                break;
                case"México": e="Mexico.png";
                break;
                case"Suécia": e="Suecia.png";
                break;
                case"Bélgica": e="Belgica.png";
                break;
                case"Inglaterra": e="Inglaterra.png";
                break;
                case"Panamá": e="Panama.png";
                break;
                case"Tunísia": e="Tunisia.png";
                break;
                case"Colômbia": e="Colombia.png";
                break;
                case"Japão": e="Japao.png";
                break;
                case"Polônia": e="Polonia.png";
                break;
                case"Senegal": e="Senegal.png";
                break;
                default: e="Brasil.png"
            }
            return e
        }
    }
});
